module.exports = __webpack_public_path__ + "static/media/profile.3bef33b7.svg";